'use client';

import React, { useState } from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import LanguageSelector from './LanguageSelector';
import AppLogo from '@/components/ui/AppLogo';

type AuthTab = 'login' | 'register';

export default function AuthFormPanel() {
  const [activeTab, setActiveTab] = useState<AuthTab>('login');

  return (
    <div className="w-full max-w-md xl:max-w-lg mx-auto px-4 py-8 sm:px-6">
      {/* Mobile logo (hidden on large screens) */}
      <div className="flex lg:hidden items-center justify-between mb-8">
        <div className="flex items-center gap-2">
          <AppLogo src="/assets/images/With_Outline_KCF_Logo-1786696132383.png" size={108} />
        </div>
        <LanguageSelector compact />
      </div>

      {/* Desktop language selector */}
      <div className="hidden lg:flex justify-end mb-6">
        <LanguageSelector />
      </div>

      {/* Tab switcher */}
      <div className="flex border-b border-navy-500 mb-7">
        <button
          onClick={() => setActiveTab('login')}
          className={`flex-1 pb-3 text-sm font-600 tracking-wide transition-all duration-200 ${
            activeTab === 'login' ? 'tab-active' : 'tab-inactive'
          }`}
        >
          Sign In
        </button>
        <button
          onClick={() => setActiveTab('register')}
          className={`flex-1 pb-3 text-sm font-600 tracking-wide transition-all duration-200 ${
            activeTab === 'register' ? 'tab-active' : 'tab-inactive'
          }`}
        >
          Create KCF ID
        </button>
      </div>

      {/* Form content */}
      <div className="animate-fade-in">
        {activeTab === 'login' ? (
          <LoginForm onSwitchToRegister={() => setActiveTab('register')} />
        ) : (
          <RegisterForm onSwitchToLogin={() => setActiveTab('login')} />
        )}
      </div>

      {/* Footer */}
      <div className="mt-8 text-center">
        <p className="text-xs text-muted-foreground">
          By continuing, you agree to KCF&apos;s{' '}
          <a href="#" className="text-primary hover:underline">Terms of Service</a>
          {' '}and{' '}
          <a href="#" className="text-primary hover:underline">Privacy Policy</a>
        </p>
        <p className="text-2xs text-muted-foreground mt-3 opacity-60">
          Your intelligence profile and Digital Twin data is encrypted and never shared without your explicit consent.
        </p>
      </div>
    </div>
  );
}